// extracted by mini-css-extract-plugin
export var box = "_5e-1";
export var checkboxRow = "_5e-8";
export var checked = "_5e-2";
export var descriptionSpacer = "_5e-a";
export var disabled = "_5e-3";
export var icon = "_5e-6";
export var input = "_5e-0";
export var labelSpacer = "_5e-9";
export var medium = "_5e-5";
export var small = "_5e-4";
export var text = "_5e-7";